export const Footer = () => {
    return (
   
        <div className="footer mt-4 d-none d-md-block">
            <hr />
            <div className="row mx-0">
                <div className="col-5 col-md-4 px-0">
                    <ul className="nav font-10 mr-100" style={{width:"max-content"}}>
                        <li className="nav-item">
                            <div className="nav-link pl-0">©{new Date().getFullYear()} All Rights Reserved</div>
                        </li>
      
                    </ul>
                </div>
                <div className="col-7 col-md-8 px-0">
                    <ul className="nav font-10">
                        {/* <li className="nav-item">
                            <a href="#" className="nav-link text-dark pl-0">Terms of Service</a>
                        </li> */}
                        <li className="nav-item">
                            <a href="https://dubaicommercity.ae/privacy-policy/" target="_blank"  className="nav-link text-dark">Privacy Policy</a>
                        </li>
                        <li className="nav-item">
                            <a href="https://dubaicommercity.ae/privacy-policy/#Use-of-cookies " target="_blank" className="nav-link text-dark">Cookies Policy</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
   
    )
}

export const ReviewFooter = () => {
    return (
        <div className="col-12 footer my-2 my-md-4">
            <div className="row px-md-40">
                <div className="col-5 col-md-4">
                    <ul className="nav font-10">
                        <li className="nav-item">
                        <li className="nav-item text-nowrap">
                            <div className="nav-link pl-0 text-nowrap">©{new Date().getFullYear()} All Rights Reserved</div>
                        </li>
                        </li>
                    </ul>
                </div>
                <div className="col-7 col-md-8">
                    <ul className="nav font-10">
                        {/* <li className="nav-item">
                            <a href="#" className="nav-link text-dark pl-0">
                                Terms of Service
                            </a>
                        </li> */}
                        <li className="nav-item">
                            <a href="https://dubaicommercity.ae/privacy-policy/" target="_blank"  className="nav-link text-dark">
                                Privacy Policy
                            </a>
                        </li>
                        <li className="nav-item">
                            <a href="https://dubaicommercity.ae/privacy-policy/#Use-of-cookies " target="_blank" className="nav-link text-dark">
                                Cookies Policy
                            </a>
                        </li>
                        
                        
                    </ul>
                </div>
            </div>
        </div>
    )
}
export const MobileFooter = () => {
    return (
        <div className="col-12 footer  my-2 my-md-4 d-block d-md-none">
            <div className="row">
                <div className="col-5 col-md-4">
                    <ul className="nav font-10">
                        <li className="nav-item text-nowrap">
                            <div className="nav-link pl-0 text-nowrap">©{new Date().getFullYear()} All Rights Reserved</div>
                        </li>
                    </ul>
                </div>
                <div className="col-7 col-md-8">
                    <ul className="nav font-10">
                        {/* <li className="nav-item">
                            <a href="#" className="nav-link text-dark pl-0">Terms of Service</a>
                        </li> */}
                        <li className="nav-item">
                            <a href="https://dubaicommercity.ae/privacy-policy/" target="_blank" className="nav-link text-dark">Privacy Policy</a>
                        </li>
                        <li className="nav-item">
                            <a  href="https://dubaicommercity.ae/privacy-policy/#Use-of-cookies " target="_blank" className="nav-link text-dark">Cookies Policy</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    
    )
}